// @flow
import { httpClient } from 'angieslist-app-platform';
import queryString from 'query-string';

const getAtlasOrgStates = (serviceProviderId: number): any => httpClient.get('/gateway/service-provider-management/v1/license/atlas/states', {
  headers: {
    'X-ANGI-CallerType': 'ServiceProvider',
    'X-ANGI-CallerId': serviceProviderId,
  },
});

const getAtlasOrgsByState = (serviceProviderId: number, stateId: number): any =>
  httpClient.get(`/gateway/service-provider-management/v1/license/atlas/organizations/getByState?${queryString.stringify({ stateId })}`, {
    headers: {
      'X-ANGI-CallerType': 'ServiceProvider',
      'X-ANGI-CallerId': serviceProviderId,
    },
  });

const getAtlasOrgFields = (serviceProviderId: number, orgId: string): any =>
  httpClient.get(`/gateway/service-provider-management/v1/license/atlas/fields/getByOrganization?${queryString.stringify({ orgId })}`, {
    headers: {
      'X-ANGI-CallerType': 'ServiceProvider',
      'X-ANGI-CallerId': serviceProviderId,
    },
  });

export default {
  getAtlasOrgStates,
  getAtlasOrgsByState,
  getAtlasOrgFields,
};



// WEBPACK FOOTER //
// ./src/modules/profile/common/licenseService.js